import { Box } from "@mui/material";
import { useEffect, useState } from "react";

import { Document, Page, pdfjs } from "react-pdf";
import { useCrefisaWhiteLabelData } from "../../hooks/useCrefisaWhiteLabelData";
import { useThemeWhiteLabel } from "../../hooks/useThemeWhiteLabel";
import { GlobalLoader } from "../GlobalLoader/GlobalLoader";
import classes from "./pdf-viewer.module.css";

// Configurar PDF.js worker usando o arquivo local
pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.mjs";

export const PdfViewer = ({ pdfUrl }: { pdfUrl: string }) => {
  const [showContent, setShowContent] = useState(false);
  const [numPages, setNumPages] = useState(null);
  const [error, setError] = useState<string | null>(null);
  const { logo, name } = useCrefisaWhiteLabelData();
  const theme = useThemeWhiteLabel();

  const onDocumentLoadSuccess = ({ numPages }) => {
    console.log('PDF carregado com sucesso:', numPages, 'páginas');
    setNumPages(numPages);
    setError(null);
  };

  const onDocumentLoadError = (error: any) => {
    console.error('Erro ao carregar PDF:', error);
    setError('Erro ao carregar o documento PDF');
  };

  useEffect(() => {
    // Validar se o pdfUrl é válido
    if (!pdfUrl) {
      setError('URL do PDF não fornecida');
      return;
    }

    // small timeout to ensure pdf worker is set correctly before the component uses it
    const timer = setTimeout(() => {
      setShowContent(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, [pdfUrl]);

  if (error) {
    return (
      <Box className={classes.contractBox} sx={{ padding: '20px', textAlign: 'center' }}>
        <p style={{ color: 'red' }}>Erro: {error}</p>
        <p>Por favor, tente novamente ou entre em contato com o suporte.</p>
      </Box>
    );
  }

  if (!showContent)
    return (
      <GlobalLoader
        logo={logo}
        alt={`${name}-logo`}
        color={theme.primaryColor}
      />
    );

  return (
    <Box className={classes.contractBox}>
      <Document
        file={pdfUrl}
        onLoadSuccess={onDocumentLoadSuccess}
        onLoadError={onDocumentLoadError}
        options={{
          cMapPacked: true
        }}
      >
        {numPages && Array.from(new Array(numPages), (_, index) => (
          <Page 
            key={`page_${index + 1}`} 
            pageNumber={index + 1}
            renderTextLayer={false}
            renderAnnotationLayer={false}
            onLoadError={(error) => {
              console.error(`Erro ao carregar página ${index + 1}:`, error);
            }}
          />
        ))}
      </Document>
    </Box>
  );
};
